<div class="grid grid-cols-1 md:grid-cols-3 gap-5">
    <div class="text-center">
        <div class="flex-start-center w-full">
            <div class="stats-item-1 rounded-tl-2xl">
                <div class="label">Liquidity</div>
                <div class="value">${{ tokenInfo ? (tokenInfo.dex_liquidity | kmb2:2) : '--' }}</div>
            </div>

            <div class="stats-item-1 rounded-tr-2xl">
                <div class="label">MKT Cap</div>
                <div class="value">${{ tokenInfo ? (tokenInfo.market_cap | kmb2:2) : '--' }}</div>
            </div>
        </div>

        <div class="grid grid-cols-3">
            <div class="stats-item-1">
                <div class="label">Price 15m%</div>
                <div class="value" [ngClass]="{'text-success': tokenInfo?.price_change_15m > 0, 'text-error': tokenInfo?.price_change_15m < 0}">
                    {{tokenInfo?.price_change_15m ? (tokenInfo?.price_change_15m | percent:'1.0-2') : '--'}}
                </div>
            </div>
            <div class="stats-item-1">
                <div class="label">Price 1h%</div>
                <div class="value" [ngClass]="{'text-success': tokenInfo?.price_change_1h > 0, 'text-error': tokenInfo?.price_change_1h < 0}">
                    {{tokenInfo?.price_change_1h ? (tokenInfo?.price_change_1h | percent:'1.0-2') : '--'}}
                </div>
            </div>
            <div class="stats-item-1">
                <div class="label">Price 1d%</div>
                <div class="value" [ngClass]="{'text-success': tokenInfo?.price_change_1d > 0, 'text-error': tokenInfo?.price_change_1d < 0}">
                    {{tokenInfo?.price_change_1d ? (tokenInfo?.price_change_1d | percent:'1.0-2') : '--'}}
                </div>
            </div>
        </div>

        <div class="stats-item-1 rounded-b-2xl h-[120px] !p-6" appLoading [loading]="!optionsToBeUpdate">
            <div class="w-full h-full" appEcharts [initialOption]="initialOption" [optionToBeUpdate]="optionsToBeUpdate"></div>
        </div>
    </div>

    <div class="stats-box">
        <div class="stats-item-2">
            <div class="label">Smart Buy</div>
            <div class="value">
                <span class="text-success" [nz-tooltip]="tokenInfo?.smart_money_last_trade_block_timestamp | date:'MM/dd HH:mm'"> ({{lastSmartBuyAge}}) </span>
                {{(tokenInfo?.smart_money_buy_amount_usd || 0) | kmb2:2}}
                <span class="text-sub-text font-normal"> | </span>
                {{tokenInfo?.smart_money_buy_percentage | percent:'1.0-2'}}
            </div>
        </div>

        <div class="stats-item-2">
            <div class="label">Smart Money/Holders</div>
            <div class="value">{{ (tokenInfo?.smart_money_swap_count_1d || 0) |kmb2:2 }}/{{ (tokenInfo?.swap_count_1d || 0) |kmb2:2 }}</div>
        </div>

        <div class="stats-item-2">
            <div class="label">Smart Money TX (24h)</div>
            <div class="value">
                {{(tokenInfo?.smart_money_swap_count_1d || 0) |kmb2:2}}
                <span class="text-sub-text font-normal">|</span>
                ${{(tokenInfo?.smart_money_swap_amount_usd_1d || 0)|kmb2:2}}
            </div>
        </div>

        <div class="stats-item-2">
            <div class="label">TX (24h)</div>
            <div class="value">
                {{(tokenInfo?.swap_count_1d || 0)|kmb2:2:true}}
                <span class="text-sub-text font-normal">|</span> ${{(tokenInfo?.swap_amount_usd_1d || 0)|kmb2:2}}
            </div>
        </div>
    </div>

    <div class="stats-box max-md:hidden">
        <div class="stats-item-2">
            <div class="value">Dev stats</div>
        </div>

        <ng-container *ngTemplateOutlet="devStatsTpl"></ng-container>
    </div>
</div>

<ng-template #devStatsTpl>
    <div>
        <div class="flex-between-center w-full gap-x-5 mb-2">
            <div class="text-sm text-sub-text">New MEME issuer</div>
            <div class="text-sm font-semibold">{{(tokenInfo?.dev_stats?.tokens_deployed_count || 0) | number:'1.0-0'}}</div>
        </div>

        <nz-avatar-group>
            <nz-avatar *ngFor="let item of hasImageDevStatsTokens" [nzSrc]="item.logo" [nzText]="item.symbol | slice:0:2"></nz-avatar>
            <nz-avatar
                *ngIf="hasImageDevStatsTokens?.length > 0 && hasImageDevStatsTokens.length < tokenInfo?.dev_stats?.tokens_deployed?.length"
                [nzIcon]="'ellipsis'"
                style="background-color: #f7f7f7; color: #dedede"
            ></nz-avatar>
        </nz-avatar-group>
    </div>

    <!-- TODO: -->
    <!-- <div class="w-full gap-x-5 !flex-between-start">
        <div class="text-sm text-sub-text flex-1">Realized PnL from Issued MEME</div>
        <div class="text-sm font-semibold text-success">$560.3M (+230.4%)</div>
    </div> -->
</ng-template>
